import { UnitProductionInteractor, UnitProductionRequest, UnitProductionStructRequest } from "../../Coordinator/UnitProduction/UnitProductionInteractor";

export class UnitProductionViewModel {
    private interactor: UnitProductionInteractor;

    constructor() {
        this.interactor = new UnitProductionInteractor();
    }

    public fetchSave(obj: any): PromiseLike<any> {
        var request = new UnitProductionRequest(
            obj["sgepunidadeproducao"] ? parseInt(obj["sgepunidadeproducao"]) : 0,
            obj["nome"] ? obj["nome"] : "",
        )
        
        return new Promise((res, rej) => {  
            this.interactor.fetchSave(request).then((result) => {
                return res(true)
            }, e => {
                return rej(e)
            });
        })
    }

    public fetchDataOne(obj: any): PromiseLike<any> {
        var request = new UnitProductionStructRequest(
            obj["sgepunidadeproducao"] ? parseInt(obj["sgepunidadeproducao"]) : 0
        )
        
        return new Promise((res, rej) => {
            this.interactor.fetchDataOne(request).then((result) => {
                return res(result)
            }, e => {
                return rej(e)
            });
        })
    }
}